import styled from 'styled-components';
import { MAIN_COLOR, GRAY_DARKER, GRAY_MEDIUM, FONT_SIZE_6 } from '../../styles/variables';
import { fontStyle } from '../../styles/mixins';
import { ZINDEX } from '../../helpers/constants';

export const ButtonToolbarNav = styled.ul`
  width: auto;
  min-width: 160px;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: ${ZINDEX.TOP};
  display: ${props => (props.openDropDown ? 'block' : 'none')};
  float: left;
  padding: 5px 0;
  margin: 2px 0 0;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  a {
    ${fontStyle(GRAY_DARKER, FONT_SIZE_6, '500')}
    text-decoration: none;
    padding: 6px 15px;
    padding-left: 15px;
    text-align: left;
    text-transform: capitalize;
    width: 100%;
    display: block;
    &:hover {
      ${fontStyle(GRAY_DARKER, FONT_SIZE_6, '500')}
      text-decoration: none;
      background-color: #f5f5f5;
    }
  }
  &:focus {
    outline: none;
  }
`;
export const ButtonToolbar = styled.div`
  cursor: pointer;
  align-self: center;
  width: 50px;
  height: 28px;
  position: relative;
  border-radius: 3px;
  background-color: unset;
  border: none;
  padding: 0;
  text-align: center;
  margin-top: 0;
  ${props => props.buttonStyle}

  &:focus {
    outline: none;
  }

  div {
    span {
      width: 4px;
      height: 4px;
      display: inline-block;
      background-color: ${GRAY_MEDIUM};
      margin-right: 4px;
      margin-bottom: 1px;
      border-radius: 100%;
      ${props => props.dotStyle}
    }
  }

  &:hover {
    div {
      span {
        background-color: ${MAIN_COLOR};
        ${props => props.hoverStyle}
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ActionBtn/style.js